var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-modal-title"},[_c('div',{staticClass:"left-slot-wrapper"},[_vm._t("left")],2),_c('div',{staticClass:"right-slot-wrapper"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }